<template>
    <div class="mt-1 justify-content-between d-flex">
        <div><b>{{ field.name }}</b></div>

        <div v-if="fieldValue !== null" style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 50%;">
            {{ fieldValue }}
        </div>
        <div v-else>Non renseigné</div>
    </div>
</template>

<script>
import {fieldsMapping} from "../../../../../static/webform"
import {mapGetters, mapMutations, mapState} from "vuex"
import _ from 'lodash'

export default {
    name: "CardRow",
    props: ['field', 'contact'],
    computed: {
        ...mapGetters('web_form', ['getCodeFromField', 'getProviderFieldValue']),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        path() {
            return fieldsMapping.find(path => path.code === this.fieldCode)
        },
        fieldValue() {
            return _.get(this.contact, this.path.property)
        }
    }
}
</script>